import { browserHistory } from "react-router";
import UpdateLesson from 'template/Docks/UpdateLesson';
import attendnaceModal from 'template/Modals/Attendance'
import deleteLesson from 'controllers/lesson/deleteLesson'
import {fetchClassLesson} from '../ducks'
import {confirm} from 'util/confirm'
import { userCan } from 'containers/__R';

export default function getDefaultTableSettings() {

  let TabComponent = this;
  let {dispatch, pagination} = this.props
  let {classId} = this.props.params
  let state = this.lessonsState === 'current'? 1: 0
	return [
    {
      title: __('Edit', 'class'),
      onClick: ({trData: lesson})=>{
        let { classDetail } = this.props;
        UpdateLesson({ lesson, classDetail: classDetail.detail, })
        .then((res) => { 
          dispatch(fetchClassLesson(classId,{
            amount_per_page: pagination.itemsCountPerPage,
            current_page_number: pagination.activePage,
            after_today: state
          })) 
        })
      },
      isDisabled: ({trData: lessonInfo})=>{
        return (lessonInfo.lesson_status == 1 || !userCan('edit_lesson'))
			}
    },
    {
      title: __('Check In', 'classdetail'),
      onClick: ({trData: lessonInfo})=>{
        attendnaceModal({
          lessonId: lessonInfo.lesson_id,
        })
          .then(()=>{
            dispatch(fetchClassLesson(classId,{
              amount_per_page: pagination.itemsCountPerPage,
              current_page_number: pagination.activePage,
              after_today: state
            }))
          })
      },
      isDisabled: ({trData: lessonInfo})=>{
        return !userCan('manually_check_in') || this.props.classDetail.detail.cState == 0
      }
    },
    {
      title: __('Delete', 'classroom'),
      onClick: ({trData: lessonInfo})=>{
        confirm(__('Deleted lessons are unrecoverable, proceed to delete?', 'lessonTable'))
        .then(() => {
          deleteLesson(lessonInfo.lesson_id)
          .then((res) => {
            dispatch(fetchClassLesson(classId, {
              amount_per_page: pagination.itemsCountPerPage,
              current_page_number: pagination.activePage,
              after_today: state
            }))
          })
        })
      },
      isDisabled: ({trData: lessonInfo})=>{
        return (lessonInfo.lesson_status == 1 || !userCan('edit_lesson'))
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/containers/pages/ClassDetail/LessonTable/table-settings.js